import { render, staticRenderFns } from "./projectlist1.vue?vue&type=template&id=bb35ad44&"
import script from "./projectlist1.vue?vue&type=script&lang=js&"
export * from "./projectlist1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports